import request from '@/utils/request'

const user = {}

user.register = (params) => request({
  url: `/api/management/register.json`,
  method: 'POST',
  data: {
    ...params,
    spCode: 'AYBS'
  }
})

user.sendMail = (params) => request({
  url: `/api/management/verifyCode.json`,
  method: 'POST',
  data: params
})

user.resetPassword = (params) => request({
  url: `/api/management/forget.json`,
  method: 'POST',
  data: params
})

user.login = params => request({
  url: `/api/management/index.json`,
  method: 'POST',
  data: params
})
export default user